export default __webpack_public_path__ + "locales/sk/RoomLogoCover.json?hash=88a3f3b56b47aea2ac6aeca9d771235f";